import React from "react";
import { useForm } from "react-hook-form";

import COIForm from "./components/COIForm";
import COIInfo from "./components/COIInfo";
import { CoiProvider } from "./contexts/Coi";
import { IClubhouseCOIData } from "./types/coi";

const ClubhouseCOI = (): React.JSX.Element => {
    const methods = useForm<IClubhouseCOIData>({
        mode: "onChange",
    });

    return (
        <section className="teamCOIInfo" data-testid="teamCOIInfo">
            <h2>Certificate of Insurance</h2>
            <p>
                All teams must upload their COI prior to their first game. The
                COI must list Baseball365 Inc. as a Certificate Holder or an
                Additional Insured. If your insurance company needs our address
                it is:
            </p>
            <p>
                {" "}
                Baseball365
                <br />
                PO Box 4
                <br />
                Janesville, WI 53547
            </p>
            <p>
                Any questions concerning your COI, please contact{" "}
                <a href="mailto:emma@majorybl.com">Emma.</a>
            </p>
            <p>
                <b>Please Note:</b> Uploading a new COI will <b>overwrite</b>{" "}
                any existing COI you have previously uploaded.
            </p>
            <CoiProvider methods={methods}>
                <COIForm />
                <COIInfo />
            </CoiProvider>
        </section>
    );
};

export default ClubhouseCOI;
